module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("dqHua"))).then(() => parcelRequire('cZeh7'));